<main>
  <div class="row align-items-center justify-content-between align-btn">
    <div class="col-12 pl-4">
      <h1 id="taxonomyTitle" class="h2 text-truncate">Taxonomies</h1>
    </div>

    <app-search class="search col" [enableAdvanceSearch]="false" [searchPlaceholder]="'Taxonomy'"
      [showBackwardNav]="false" (isAdvSearchFrontFacingEvnt)="fnAdvSearchFrontFacing($event)">
    </app-search>

    <div class="col-auto project--filter d-flex justify-content-end align-items-center">
      <div class="mr-3 d-flex align-items-center">
        <div class="d-inline-flex mr-2" *ngIf="!isAdvSearchFrontFacing">
          <p class="d-inline-flex font-bold mb-0 mr-2" *ngIf="viewType !== 'listview'">Sort by:</p>
          <app-sort-list [hidden]="viewType === 'listview'" #sortListRef [sortingArray]="taxonomyList" 
            [isProject]="false" [selectedSortOption]="'title'" [sortOptions]="sortOptions"></app-sort-list>
        </div>

        <!-- Start new sorting option -->
        <div class="d-inline-flex mr-2 form-control" *ngIf="isAdvSearchFrontFacing">
          <p class="d-inline-flex font-bold mb-0 mr-2">Sort by:</p>
          <div class="dropdown btn-group btn-group-sort">
            <button class="btn btn__filter btn-clear btn-sm dropdown-toggle dropdown-toggle-adv font-bold p-0" type="button" id="sortlistDropDown" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              {{sortTitleOrder}}
            </button>
            <div class="dropdown-menu dropdown-menu-right px-2" aria-labelledby="sortlistDropDown">
              <button  (click)="sortByTitle('asc')" class="btn btn-clear font-2x dropdown-item" aria-label="Title (A-Z) option">Title (A-Z)</button>
              <button  (click)="sortByTitle('desc')" class="btn btn-clear font-2x dropdown-item" aria-label="Title (Z-A) option">Title (Z-A)</button>
              <button (click)="sortData('asc')" class="btn btn-clear font-2x dropdown-item" aria-label="Published (Asc) option">Published (Asc)</button>
              <button  (click)="sortData('desc')" class="btn btn-clear font-2x dropdown-item" aria-label="Published (Desc) option">Published (Desc)</button>
            </div>
          </div>
        </div>
        <!-- End new Sorting option -->
        <app-view-type [ngStyle]="{'display': isAdvSearchFrontFacing ? 'none' : 'block'}" (selectedViewTypeEvent)="changeView($event)"></app-view-type>
        <button *ngIf="isAdvSearchFrontFacing" data-tooltip="Print preview"
          class="btn btn-ds--secondary btn-icon btn-sm tooltip top top-right position-relative" aria-label="Print preview" aria-pressed="false"  (click)="printPreview()"><span aria-hidden="true"
            class="material-icons-outlined button-icon font-4x">print</span></button>
      </div>
    </div>
  </div>
  <!-- end of project filter section  -->

  <ng-container *ngIf="viewType === 'listview';then list_view else card_view"  ></ng-container>

  <ng-template #list_view >
    <app-data-table *ngIf="!isAdvSearchFrontFacing" [showMenu]="false" [tableCategory]="'frontfacing taxonomy'" class="w-100"
      [columnList]="listOfColumn" [dataSet]="taxonomyList" [optionList]="optionList" [defaultSortBy]="listOfColumn[1]"
      [showLoader]="taxonomyLoader" [searchText]="searchingText" (linkClicked)="onTaxonomySelected($event)">
    </app-data-table>
  </ng-template>

  <ng-template #card_view>

    <div class="mt-3 mx-0 container-fluid p-0" role="grid" aria-labelledby="taxonomyTitle" *ngIf="!isAdvSearchFrontFacing">
      <div class="w-100 d-flex flex-wrap" role="row">
        <!-- start of loop -->
        <div class="col-md-6 col-lg-4 col-xl-3 card-tile"
          *ngFor="let item of taxonomyList| customFilter: getColumnFilterObj() |slice:startIndex:lastIndex;let i = index"
          role="gridcell">
          <div class="card" id="card-{{i}}">
            <div class="card-body">
              <h2 class="card-title">
                <button class="btn btn-icon btn-title text-left p-0 font-5x font-bold d-block w-100"
                  (click)="onTaxonomySelected(item)">{{item.title}}</button>
                <span class="d-block w-100 font-2x"
                  *ngIf="item?.description && item?.description.length">{{item.description}}</span>
              </h2>
              <p class="mb-0 text-truncate">Published: {{ changeDateToLocalTimeZone(item.updated_at)| amCalendar:{sameDay:'[Today
              at] h:mm A'} }}</p>

            </div>
          </div>
        </div>
        <!-- end of loop -->
      </div>

    </div>
    <app-pagination *ngIf="filterData && filterData.length > minItemPerPage"
      [dataLength]="filterData ? filterData.length : 0" (displayItemRangeEvent)="showDataInRange($event)">
    </app-pagination>
  </ng-template>

  <!-- advance search listing -->
  <app-adv-search-taxonomy-listing *ngIf="isAdvSearchFrontFacing" [advSearchlist]="dataSetAdvSearchlist" [itemsResponse]="bodyItems" [allListValueCount]="allListValueCount"
  (sortDatalistEvent)="sortDatalist($event)" [documentIds]="documentIds">
  </app-adv-search-taxonomy-listing>
  <!-- end of project margin -->
</main>